import { ExternalLink, MousePointerClick } from "lucide-react";

export function LandingHowItWorks() {
  return (
    <section id="how-it-works" className="py-20 md:py-28 bg-white" data-testid="landing-how-it-works-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] font-semibold text-[#2563EB] mb-3">
            <MousePointerClick className="w-3.5 h-3.5" /> Попробуйте прямо сейчас
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
            Это настоящий личный кабинет — кликайте сами
          </h2>
          <p className="mt-4 text-sm sm:text-base text-slate-600 max-w-2xl mx-auto">
            Ниже открыт живой демо-кабинет КриптоДок с реальными данными: входящие, отправка, подписание, журнал действий.
            Регистрация не нужна — переходите по разделам слева и пробуйте всё своими руками.
          </p>
        </div>

        <div className="rounded-2xl overflow-hidden shadow-[0_20px_60px_-15px_rgba(15,23,42,0.18)]" data-testid="landing-embedded-demo-wrapper">
          <iframe
            title="Демо-кабинет КриптоДок"
            src="/?embed=1"
            loading="lazy"
            className="w-full h-[480px] sm:h-[620px] lg:h-[720px] border-0 block"
            data-testid="landing-embedded-demo-iframe"
          />
        </div>

        <div className="text-center mt-5">
          <a
            href="/?embed=1"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-[#2563EB] hover:text-[#1D4ED8]"
            data-testid="landing-embedded-demo-fullscreen-link"
          >
            Открыть демо на весь экран <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </section>
  );
}
